export default __webpack_public_path__ + "static/media/intro3.08c60fa4.jpg";